import React from 'react';
import styles from 'Custom/Footer/BrandFooter.module.scss';
import ContainerXL from 'Nori/Container/ContainerXL';
import RichText from 'Custom/RichText';
import Button from 'Nori/Button';
import ButtonStyles from 'Nori/Button/index.module.scss';

const BLOCK_BACKGROUND = {
  secondary2Light: styles.secondary2Light,
  secondary4Light: styles.secondary4Light,
  default: styles.secondary2Light,
};

const BUTTON_VARIANT = {
  secondary2Light: 'primaryLight',
  secondary4Light: 'primaryLight',
  default: 'primaryLight',
};

const BUTTON_SIZES = {
  small: ButtonStyles.small,
};

const BannerCTA = ({
  className = '',
  color = '#2A4875',
  button = {
    href: '/enrollment/',
    label: 'Register My NEXPLANON',
    target: '_self',
    size: 'small',
  },
  size = 'small',
  moduleName,
  moduleNo,
  children,
  ...props
}) => {
  const backgroundClassName =
    BLOCK_BACKGROUND[color] || BLOCK_BACKGROUND.default;
  const buttonVariant = BUTTON_VARIANT[color] || BUTTON_VARIANT.default;
  const sizeClassName = BUTTON_SIZES[size] || BUTTON_SIZES.default;

  return (
    <div
      className={`${styles.wrapper} ${backgroundClassName} ${className}`}
      {...props}
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="Bottom Nav"
      data-design-module_name="Bottom Nav"
      data-design-module_no="00"
      data-qa-tag="brand-footer-wrapper"
    >
      <ContainerXL className={styles.containerWrap} data-qa-tag="brand-footer-container">
        <RichText
          className={styles.mainContainer}
          data-qa-tag="richText-brand-container"
        >
          <div className={styles.copy} data-qa-tag="brand-footer-copy">
            <p className={styles.copyTitle} data-qa-tag="brand-footer-title">
              Already on NEXPLANON?
            </p>
            <p
              className={styles.copySubTitle}
              data-qa-tag="brand-footer-subTitle"
            >
              Receive tips to help you with your journey on NEXPLANON.
            </p>
          </div>{' '}
          <Button
            className={`${sizeClassName} ${styles.whiteButton}`}
            type={buttonVariant}
            href={button.href}
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Link"
            data-design-label={button.label}
            data-design-nori_id="Bottom Nav"
            data-design-module_name="Bottom Nav"
            data-design-module_no="00"
            data-qa-tag="register-my-nexplanon-button"
          >
            {button.label}
          </Button>
        </RichText>
      </ContainerXL>
    </div>
  );
};

export default BannerCTA;
